import { render } from "./ActivityTickets.vue?vue&type=template&id=256b17b2&scoped=true&ts=true"
import script from "./ActivityTickets.ts?vue&type=script&lang=ts"
export * from "./ActivityTickets.ts?vue&type=script&lang=ts"

import "./ActivityTickets.vue?vue&type=style&index=0&id=256b17b2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256b17b2"]])

export default __exports__